

































































































import Vue from 'vue';
import Const from '@/classes/const';
import SiteSetting from '@/classes/siteSetting';
import CommonCalc from '@/classes/commonCalc';

export default Vue.extend({
  name: 'ItemInput',
  props: {
    index: {
      type: Number,
      required: true,
    },
    setting: {
      type: SiteSetting,
      required: true,
    },
  },
  data: () => ({
    allLevel: 0,
  }),
  computed: {
    typeName(): string {
      if (this.index >= 0) {
        const typeId = this.setting.planeInitialLevels[this.index].id;
        const type = Const.ITEM_API_TYPE.find((v) => v.id === typeId);
        return type ? type.name : '';
      }
      return '一括変更';
    },
    typeId(): number {
      return this.index >= 0 ? this.setting.planeInitialLevels[this.index].id : 0;
    },
    level(): number {
      return this.index >= 0 ? this.setting.planeInitialLevels[this.index].level : this.allLevel;
    },
    levelValue(): number {
      return CommonCalc.getProfLevel(this.level);
    },
  },
  methods: {
    setLevel(value: number) {
      if (this.index >= 0) {
        this.setting.planeInitialLevels[this.index].level = Const.PROF_LEVEL_BORDER[value];
      } else {
        // 一括
        for (let i = 0; i < this.setting.planeInitialLevels.length; i += 1) {
          this.setting.planeInitialLevels[i].level = Const.PROF_LEVEL_BORDER[value];
        }
      }
    },
    getLevelValue(value: number) {
      return Const.PROF_LEVEL_BORDER[value];
    },
  },
});
